const fromArrayBuffer = (arraybuffer, fileName) => {
  /*
   * Generate a pivot <a> tag to download passed ArrayBuffer as a spreadsheet.
   *
   * @param arraybuffer {ArrayBuffer} - Arraybuffer containing the data
   * @param fileName {String} - the desired filename
   *
   * @return url to blob
   */

  const blob = new Blob([arraybuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

  const blobURL = window.URL.createObjectURL(blob)

  let fakeLinkEl = document.createElement('a')
  fakeLinkEl.href = blobURL
  fakeLinkEl.download = `${fileName}.xlsx`

  document.body.appendChild(fakeLinkEl)
  fakeLinkEl.style = 'display: none'
  fakeLinkEl.click()

  return blobURL
}

export { fromArrayBuffer }
